import addModal from './addModal.vue';
import { claimsParamList, claimsParamDetail, claimsParamDelete } from './request';
import { columns, paramsTypeObj } from './utils';
export default {
  components: {
    addModal
  },
  data() {
    return {
      columns,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      paramsTypeObj,
      form: {
        params: ''
      },
      tableData: [],
      selectedRowKeys: []
    };
  },
  created() {
    this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = this.pagination.page = 1;
      this.getListData();
    },
    async getListData() {
      const obj = {
        name: this.form.params,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      };
      const {
        items,
        totalNum
      } = await claimsParamList(obj);
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.page -= 1;
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    onAdd() {
      this.$refs.addRef.openModal('add', false, true);
    },
    async onEdit(id) {
      const res = await claimsParamDetail({
        claimsParamId: id
      });
      this.$refs.addRef.openModal('edit', res, true);
    },
    async onDelete(id) {
      await this.$alert(this.$t('是否确认删除?'), {
        confirmButtonText: this.$t('确定')
      });
      await claimsParamDelete({
        claimsParamId: Array.isArray(id) ? id : [id]
      });
      this.$message.success(this.$t('删除成功'));
      this.getListData();
    },
    async batchDelete() {
      if (this.selectedRowKeys.length) {
        await this.onDelete(this.selectedRowKeys);
        this.selectedRowKeys = [];
      } else {
        this.$message.error(this.$t('请选择要删除的数据'));
      }
    },
    tablePageChange(val) {
      this.pagination = val;
      this.pagination.page = val.current;
      this.getListData();
    },
    onSelectChange(val, all) {
      this.selectedRowKeys = val;
    }
  }
};